/*
export function someGetter (state) {
}
 */

export const sideMenuOpen = (state)=>  {
  return state.isSideMenuOpen
}

export const disablePullToRefresh = (state) => state.disablePullToRefresh